"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropUntil = exports.drop = void 0;
function drop(howMany, things) {
    var doit = function (things) {
        return things.slice(howMany);
    };
    return typeof things === 'undefined' ? doit : doit(things);
}
exports.drop = drop;
function dropUntil(fn, ts) {
    var doit = function (ts) {
        var i;
        for (i = 0; i < ts.length; i++) {
            if (fn(ts[i])) {
                break;
            }
        }
        return ts.slice(i);
    };
    return typeof ts === 'undefined' ? doit : doit(ts);
}
exports.dropUntil = dropUntil;
